<div class="flex center justify-start gap30">
    <button type="button" class="btn btn-back" (click)="goBack()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4 10L3.29289 10.7071L2.58579 10L3.29289 9.29289L4 10ZM21 18C21 18.5523 20.5523 19 20 19C19.4477 19 19 18.5523 19 18L21 18ZM9 15L8.29289 15.7071L3.29289 10.7071L4 10L4.70711 9.29289L9.70711 14.2929L9 15ZM4 10L3.29289 9.29289L8.29289 4.29289L9 5L9.70711 5.70711L4.70711 10.7071L4 10ZM4 10L4 9L14 9L14 10L14 11L4 11L4 10ZM20 16L21 16L21 18L20 18L19 18L19 16L20 16ZM14 10L14 9C17.866 9 21 12.134 21 16L20 16L19 16C19 13.2386 16.7614 11 14 11L14 10Z"
                fill="#33363F" />
        </svg>
    </button>
    <h2 [appTranslate]="'APPLICATION_DETAILS'"></h2>
</div>


<div class="appDetails">
    <h2 [appTranslate]="'DETAILS'"></h2>
    <h3 [appTranslate]="'PERSONAL_DATA'"></h3>
    <div class="model-row">
        <span [appTranslate]="'NAME_SURNAME'"></span>
        <b>{{appModel.Name}} {{appModel.Surname}}</b>
    </div>
    <div class="model-row ">
        <span [appTranslate]="'CITY'"></span>
        <b>{{appModel.City}}</b>
    </div>

    <h3 [appTranslate]="'APPLICATION_DETAILS'"></h3>
    <div class="model-row">
        <span [appTranslate]="'APPLICATION_DURATION'"></span>
        <b>{{appModel.DateApproved | date:'dd.MM.yyyy'}} - {{dateExpiered | date:'dd.MM.yyyy'}}</b>
    </div>
    <div class="model-row">
        <span [appTranslate]="'APPLICATION_REJECT_REASON'"></span>
        <b>{{ appModel.ReasonForReject || '/' }}</b>
    </div>

    <h3 [appTranslate]="'LICENSE_TYPE'"></h3>
    <div class="model-row">
        <span [appTranslate]="'LICENSE_TYPE'"></span>
        <b>{{appModel.PermitTypeName}}</b>
    </div>
    <div class="model-row">
        <span [appTranslate]="'ZONE'"></span>
        <b>{{appModel.PermitName}}</b>
    </div>
    <div class="model-row">
        <span [appTranslate]="'PARKING_TYPE'"></span>
        <b>{{appModel.ParkingTypeName}}</b>
    </div>


    <!-- <div *ngFor="let car of appModel.Vehicles; ">
        <div class="model-row">
            <span [appTranslate]="'VEHICLE'"></span>
            <b>{{ car.Model }} {{ car.Registration }} <span [appTranslate]="car.FuelTypeName"></span> </b>
            <b>
                <div>
                    {{ car.Price }}
                    <b [appTranslate]="'DENARS'"></b>
                </div>
                <div *ngFor="let order of car.OrderDetailsJson;">
                    <b [appTranslate]="'Платено'"></b> :
                    {{ order.Amount }}
                    <br>
                    <b [appTranslate]="'Од'"></b> :
                    {{ order.DateFrom | date:'dd.MM.yyyy' }}
                    <br>
                    <b [appTranslate]="'До'"></b> :
                    {{ order.DateTo | date:'dd.MM.yyyy' }}
                    <br>
                </div>
            </b>
        </div>
    </div> -->
    <div *ngFor="let car of appModel.Vehicles" class="vehicle-block">
        <div class="model-row vehicle-row">
            <span [appTranslate]="'VEHICLE'"></span>

            <div class="vehicle-info">
                <div class="vehicle-main">
                    <b>{{ car.Model }} {{ car.Registration }} <span [appTranslate]="car.FuelTypeName"></span></b>

                    <div class="vehicle-price">
                        {{ car.Price }}
                        <b [appTranslate]="'DENARS'"></b>
                    </div>
                </div>

                <div class="vehicle-orders" *ngIf="car.OrderDetailsJson?.length > 0">
                    <div class="order-item" *ngFor="let order of car.OrderDetailsJson">
                        <div><b [appTranslate]="'PAYED'"></b> : {{ order.Amount }}</div>
                        <div><b [appTranslate]="'OF'"></b> : {{ order.DateFrom | date:'dd.MM.yyyy' }}</div>
                        <div><b [appTranslate]="'TO'"></b> : {{ order.DateTo | date:'dd.MM.yyyy' }}</div>
                    </div>
                </div>
            </div>

        </div>
    </div>


    <div class="price-row">
        <div class="price_div">
            <p [appTranslate]="'TOTAL_SUM'"></p>
            <div class="flex center gap5">
                <span>{{appModel.Price}}</span><span [appTranslate]="'DENARS'"></span>
            </div>
        </div>
        <div class="group price_div" *ngIf="appModel.DurationType==2 && appModel.PaymentTypeId == 1">
            <span [appTranslate]="'DATE_FROM'"></span>
            <app-mat-datepicker-loc [minDate]="today" [preselectedDate]="appModel.DateSelected"
                (dateSelected)="onDateSelectedFrom($event)" #datepickerFrom></app-mat-datepicker-loc>
        </div>

        <div class=" group price_div" *ngIf="appModel.DurationType==2 && appModel.PaymentTypeId == 2">
            <span [appTranslate]="'CHOOSE_MONTH'"></span>
            <select name="month" class="form-control" [(ngModel)]="selectedMonth"
                (ngModelChange)="onMonthChange(selectedMonth)">
                <option *ngFor="let month of months" [value]="month.Id">
                    <span [appTranslate]="month.Name"></span>
                </option>
            </select>
        </div>
        <div class=" group price_div" *ngIf="appModel.DurationType==1">
            <span style="text-transform: none;" [appTranslate]="'PAYMENT_PRIORITY'"></span>
            <div>
                <div>
                    <span [appTranslate]="'OF'"> </span>
                    <span>: {{ this.appModel.DateSelected | date:'dd.MM.yyyy' }} </span>
                </div>
                <div>
                    <span [appTranslate]="'TO'"> </span>
                    <span>: {{ dateTo| date:'dd.MM.yyyy' }} </span>
                </div>
            </div>

        </div>

        <div class=" group price_div" *ngIf="appModel.DurationType==2">
            <div class="form-group price_div">
                <span [appTranslate]="'MOUTHS_TO_PAY'"></span>
                <input class="form-control" type="number" name="zone" value=1 [(ngModel)]="appModel.Months"
                    (change)="calculateTotal()" min="1" max="12">
                <small *ngIf="invalidMonthNumber">Невалиден број на
                    месеци</small>
            </div>
        </div>
    </div>

    <div class="profile-actions" *ngIf="!isAdmin">
        <button *ngIf="canExtend " [appTranslate]="'EXTEND_CONTRACT'" type="button" class="btn btn-next"
            aria-label="Extend contract" (click)="extend()"></button>
        <button *ngIf="appModel.Status==0" [appTranslate]="'PAY'" type="button" class="btn btn-primary" (click)="pay()"
            aria-label="Pay"></button>
    </div>
</div>
<section class="documents-panel"
    *ngIf="appModel.IdFiles.length > 0 || appModel.TrafficLicences.length > 0 || appModel.DriversLicences.length > 0 || appModel.AdditionalFiles.length > 0">
    <h3 [appTranslate]="'DOCUMENTS'"></h3>

    <div class="doc-group" *ngIf="appModel.IdFiles.length > 0">
        <h4 [appTranslate]="'ID'"></h4>
        <ul class="documents-list">
            <li *ngFor="let item of appModel.IdFiles">
                <a [href]="item.Path" target="_blank" rel="noopener noreferrer">
                    <span class="doc-icon" aria-hidden="true"></span>
                    <span class="doc-name">{{ item.name }}</span>
                </a>
            </li>
        </ul>
    </div>
    <div class="doc-group" *ngIf="appModel.DriversLicences.length > 0">
        <h4 [appTranslate]="'DRIVERS_LICENSE'"></h4>
        <ul class="documents-list">
            <li *ngFor="let item of appModel.DriversLicences">
                <a [href]="item.Path" target="_blank" rel="noopener noreferrer">
                    <span class="doc-icon" aria-hidden="true"></span>
                    <span class="doc-name">{{ item.name }}</span>
                </a>
            </li>
        </ul>
    </div>
    <div class="doc-group" *ngIf="appModel.TrafficLicences.length > 0">
        <h4 [appTranslate]="'TRAFFIC_LICENSE'"></h4>
        <ul class="documents-list">
            <li *ngFor="let item of appModel.TrafficLicences">
                <a [href]="item.Path" target="_blank" rel="noopener noreferrer">
                    <span class="doc-icon" aria-hidden="true"></span>
                    <span class="doc-name">{{ item.name }}</span>
                </a>
            </li>
        </ul>
    </div>
    <div class="doc-group" *ngIf="appModel.AdditionMandatoryFiles.length > 0">
        <h4 [appTranslate]="'ADDITION_MANDATORY_FILES'"></h4>
        <ul class="documents-list">
            <li *ngFor="let item of appModel.AdditionMandatoryFiles">
                <a [href]="item.Path" target="_blank" rel="noopener noreferrer">
                    <span class="doc-icon" aria-hidden="true"></span>
                    <span class="doc-name">{{ item.name }}</span>
                </a>
            </li>
        </ul>
    </div>
    <div class="doc-group" *ngIf="appModel.AdditionalFiles.length > 0">
        <h4 [appTranslate]="'ADDITIONAL_FILES'"></h4>
        <ul class="documents-list">
            <li *ngFor="let item of appModel.AdditionalFiles">
                <a [href]="item.Path" target="_blank" rel="noopener noreferrer">
                    <span class="doc-icon" aria-hidden="true"></span>
                    <span class="doc-name">{{ item.name }}</span>
                </a>
            </li>
        </ul>
    </div>
</section>
<section class="documents-panel">
    <h3 [appTranslate]="'RIGHTS_AND_DOCUMENTS'"></h3>
    <div class="doc-group">
        <a href="/Content/documents/{{(appModel.CityEn | lowercase)}}/Права и обврски на корисникот и давателот на услугата паркирање.pdf"
            class="btn btn-link">
            <img src="/assets/images/document-text.svg" alt="" aria-hidden="true">
            <span [appTranslate]="'RIGHTS_AND_DOCUMENTS'"></span>
        </a>
    </div>
</section>


<div class="loader" *ngIf="myLoaderService.isLoading | async"></div>